import React from 'react';

import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { ErrorBoundary } from '@confluence/error-boundary/entry-points/ErrorBoundary.ts';
import { isStableUIEnabledForTests } from '@confluence/e2e-url-override/entry-points/isStableUIEnabledForTests.ts';
import { StandardToPremiumModalMountComponent } from '@confluence/experiment-edition-awareness-for-standard-to-premium';
import { TrialPlanComparisonModalMountComponent } from '@confluence/persistent-upgrade/entry-points/lazyTrialPlanComparisonModal.ts';
import { TrialFlags } from '@confluence/trial-components/entry-points/TrialFlags.tsx';

export const TrialAndUpgradeComponentsLoader = (): React.JSX.Element | null => {
	if (isStableUIEnabledForTests()) {
		return null;
	}

	return (
		<ErrorBoundary
			attribution={Attribution.GROWTH_LUNA}
			attributes={{
				errorBoundaryId: 'GlobalComponents-GrowthLuna',
			}}
		>
			<TrialPlanComparisonModalMountComponent />
			<StandardToPremiumModalMountComponent />
			<TrialFlags />
		</ErrorBoundary>
	);
};
